import { styled } from '@/src/stitches.config'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'

const FieldWrapper = styled('div', {
    alignItems: 'center',
    display: 'flex',
    mb: 10,
})

const StyledCheckbox = styled(CheckboxPrimitive.Root, {
    all: 'unset',
    backgroundColor: '$white',
    width: 25,
    height: 25,
    borderRadius: 4,
    boxSizing: 'border-box',
    border: '2px solid $secondary',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 25,
    "&[data-state='checked']": {
        backgroundColor: '$secondary',
    },
    '&:focus': {
        outline: '1px solid $secondary',
    },
    variants: {
        scheme: {
            whiteBg: {
                "&[data-state='checked']": {
                    backgroundColor: '$white',
                },
            },
        },
    },
})

const StyledIndicator = styled(CheckboxPrimitive.Indicator, {
    color: '$white',
    variants: {
        scheme: {
            whiteBg: {
                color: '$secondary',
            },
        },
    },
})

const Label = styled('label', {
    fontSize: 15,
    lineHeight: 1,
    userSelect: 'none',
    paddingLeft: 15,
})

export const CheckboxInputWithLabel = (props: any) => {
    const {
        initialError,
        initialTouched,
        initialValue,
        touched,
        scheme,
        labelCss = {},
        ...theRest
    } = props
    const id = `cb_${props.name}_${props.value}`
    return (
        <FieldWrapper>
            <StyledCheckbox {...theRest} id={id} scheme={scheme}>
                <StyledIndicator scheme={scheme}>
                    <FontAwesomeIcon icon={faCheck} />
                </StyledIndicator>
            </StyledCheckbox>
            <Label htmlFor={id} style={labelCss}>
                {props.label}
            </Label>
        </FieldWrapper>
    )
}
